import { BottomNavbar } from "../components/BottomNavbar";
import { Header } from "../components/Header";
import { Metrics } from "../components/Metrics";
// import { MyTraining } from "../components/MyTraining";
// import { News } from "../components/News";
// import { OtherTraining } from "../components/OtherTraining";
// import { SearchBar } from "../components/SearchBar";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
// import { logout } from "../components/funtionsBD/login";

// function redux
import { setUserName } from "../redux/user_SliceReducer";
import { setYourMetrics } from "../redux/yourMetrics_SliceReducer";

//API
import { getYourMetric } from "../components/funtionsBD/home/yourMetrics";
import { getNews } from "../components/funtionsBD/home/news";
import { getMyTraining } from "../components/funtionsBD/home/myTraining";
import { getOtherTrainings } from "../components/funtionsBD/home/otherTrainings";

export function Home() {
  // const navigate = useNavigate();
  // const dispatch = useDispatch();

  // const [token] = useState(localStorage.getItem("token"));
  // const userName = useSelector((state) => state.user.name);
  // const cardData = useSelector((state) => state.yourMetrics.cars);
  // const [slides, setSlides] = useState([]);
  // const [trainingData, setTrainingData] = useState([]);
  // const [data, setData] = useState([]);

  // // Check if a user is already stored in localStorage
  // useEffect(() => {
  //   const user = JSON.parse(localStorage.getItem("user"));
  //   if (!user) {
  //     logout(token);
  //     navigate("/");
  //   } else {
  //     dispatch(setUserName(user.user_first_name));
  //   }
  // }, [navigate]);

  // // Check if a Your metric is already stored in store redux
  // const getYourMetricLocal = async () => {
  //   const cards = await getYourMetric();
  //   console.log(cards);
  //   dispatch(setYourMetrics(cards));
  //   console.log(dispatch(setYourMetrics(cards)));
  // };

  // useEffect(() => {
  //   if (!cardData || cardData.length === 0) {
  //     getYourMetricLocal();
  //   }
  // }, []);

  // // get news
  // const getNewsLocal = async () => {
  //   const slides = await getNews();
  //   setSlides(slides);
  // };
  // useEffect(() => {
  //   getNewsLocal();
  // }, []);

  // // get trainingData
  // const trainingDataLocal = async () => {
  //   const { status, message, data } = await getMyTraining(token);
  //   if (status === "success") {
  //     console.log(data);
  //     setTrainingData(data);
  //   } else {
  //     if (message === "Token is not valid") {
  //       await logout(token);
  //       navigate("/");
  //     } else {
  //       console.log(message);
  //     }
  //   }
  // };
  // useEffect(() => {
  //   trainingDataLocal();
  // }, []);

  // // get otherTrainings (data)
  // const getOtherTrainingsLocal = async () => {
  //   const { status, message, data } = await getOtherTrainings(token);
  //   if (status === "success") {
  //     console.log(data);

  //     setData(data);
  //   } else {
  //     if (message === "Token is not valid") {
  //       await logout(token);
  //       navigate("/");
  //     } else {
  //       console.log(message);
  //     }
  //   }
  // };
  // useEffect(() => {
  //   getOtherTrainingsLocal();
  // }, []);

  return (
    <>
      {/* <div id="adminRoot">
        <Header userName={userName ?? "Giana Admin"} />
        <SearchBar />
        <Metrics cardData={cardData} />
        <News slides={slides} />
        <MyTraining trainingData={trainingData} />
        <OtherTraining data={data} />
      </div> */}
    </>
  );
}
